module.exports = __webpack_public_path__ + "img/12.2.TN.f5c241df.png";